<script>
  import { loadConfig } from "$lib/utils/helpers.js";

  const config = loadConfig();
  const year = new Date().getFullYear();
</script>

<footer class="shrink-0 border-t-2 border-[#3a3a4a] bg-[#0e0e16]">
  <div class="w-full mx-auto px-4 py-4">
    <div class="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-center text-xs text-[#8a8a92]">
      <span>
        © {config.app.copyright}{year > config.app.copyright
          ? "-" + year
          : ""}
        {config.company.name}. All rights reserved.
      </span>
      <div class="flex items-center gap-x-4">
        <a href="/terms" class="hover:text-[#a855f7] transition-colors">Terms</a>
        <span class="text-[#3a3a4a]">│</span>
        <a href="/privacy" class="hover:text-[#a855f7] transition-colors">Privacy</a>
        <span class="text-[#3a3a4a]">│</span>
        <a href="/cookies" class="hover:text-[#a855f7] transition-colors">Cookies</a>
      </div>
    </div>
  </div>
</footer>
